module.exports = __webpack_public_path__ + "media/rewrite_the_stars.6297f4ae.mp3";